module.exports = __webpack_public_path__ + "img/manufacture@2x.4f96ac3.jpg";